// @flow
import getEndpointUrl from 'api/getEndpointUrl';
import checkResponse from 'api/checkIfResponseIsOK';
import wrapWithNetworkError from 'api/wrapWithNetworkError';

const PROPERTY_NAME_LIST = [
  // publication
  'IS_LIVE_MODERATION',
  'LEVEL1_AUTO_APPROVE',
  'LEVEL2_AUTO_APPROVE_LEVEL',
  'LEVEL2_AUTO_APPROVE_LEVEL_FOR_SHARED_REVIEWS',
  'PA_QUESTION_LEVEL1_AUTO_APPROVE',
  'PA_QUESTION_LEVEL2_AUTO_APPROVE',
  'PA_ANSWER_APO_LEVEL1_AUTO_APPROVE',
  'PA_ANSWER_COMMUNITY_LEVEL1_AUTO_APPROVE',
  'PA_ANSWER_CROWD_LEVEL1_AUTO_APPROVE',
  'PA_ANSWER_LEVEL2_AUTO_APPROVE',
  // brand engage
  'BRAND_ENGAGE_TIER',
  'BRAND_ENGAGE_TYPE',
  // portal
  'IS_PORTAL',
  // Show default client moderation channels
  'SHOW_CLIENT_MODERATION_CHANNELS',
  'ENABLE_UGC_EDITING',
  'ENABLE_VISUAL_ANSWERS',
  'ss_account_information_id',
  'ENABLE_MEDIA_FEATURED_FLAG',
  //
  'SOCIAL_COLLECTION_WYNG_DIRECT_ACCESS',
  'OCADO_PORTAL_LANGUAGES',
];
const PROPERTY_NAME_KEYS = PROPERTY_NAME_LIST.join(',');

export const getClientProperties = wrapWithNetworkError(function _getAppConfig(
  token: string,
  merchantGroupId: Id
): Promise<ClientProperty | Error> {
  const fetchUrl = getEndpointUrl(
    `/getAppConfig/merchantGroupProps/g${merchantGroupId}/keys/${PROPERTY_NAME_KEYS}`
  );
  const fetchOptions = {
    headers: {
      Authorization: token,
    },
  };

  return fetch(fetchUrl, fetchOptions)
    .then(response => checkResponse(response))
    .then(response => response.json());
});



// WEBPACK FOOTER //
// ./src/containers/client/clientPropertiesApi.js